import { render, staticRenderFns } from "./before_check.vue?vue&type=template&id=38a25849&scoped=true&"
import script from "./before_check.vue?vue&type=script&lang=js&"
export * from "./before_check.vue?vue&type=script&lang=js&"
import style0 from "./before_check.vue?vue&type=style&index=0&id=38a25849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a25849",
  null
  
)

export default component.exports